import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core'

import { subscriptionHistoryService } from '../services'
import '../assets/SubscriptionHistoryDialog.css'

const SubscriptionHistoryDialog = ({ open, onClose, studentCpf }) => {
  const [loading, setLoading] = useState(false)
  const [history, setHistory] = useState([])
  const [error, setError] = useState(null)
  const [downloadingPdf, setDownloadingPdf] = useState(null)

  useEffect(() => {
    if (!open) return

    const fetchHistory = async () => {
      setLoading(true)
      setError(null)

      try {
        const { success, payload } = await subscriptionHistoryService.getSubscriptionHistory(studentCpf)

        if (success && payload?.history) {
          setHistory(payload.history)
        } else {
          setError('Não foi possível carregar o histórico')
        }
      } catch (err) {
        setError('Erro ao carregar histórico')
      } finally {
        setLoading(false)
      }
    }

    fetchHistory()
  }, [open, studentCpf])

  const handleDownloadDetails = async (id) => {
    setDownloadingPdf(id)
    try {
      await subscriptionHistoryService.getPdf(id)
    } catch (error) {
      console.error('Erro ao baixar PDF:', error)
    } finally {
      setDownloadingPdf(null)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableRestoreFocus
      maxWidth="lg"
      fullWidth
      PaperProps={{
        className: 'subscription-history-dialog'
      }}
    >
      <DialogTitle>Histórico de solicitações (pré-matrículas)</DialogTitle>
      <DialogContent className="subscription-history-content">
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <CircularProgress />
          </div>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : history.length === 0 ? (
          <DialogContentText>
            Nenhum histórico encontrado.
          </DialogContentText>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className="subscription-history-table-header">Nome</TableCell>
                <TableCell className="subscription-history-table-header">Cpf</TableCell>
                <TableCell className="subscription-history-table-header">Data/Hora</TableCell>
                <TableCell className="subscription-history-table-header">Operação</TableCell>
                <TableCell className="subscription-history-table-header"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map(item => (
                <TableRow key={item.id} hover>
                  <TableCell className="subscription-history-table-cell">{item.studentName}</TableCell>
                  <TableCell className="subscription-history-table-cell">
                    <Typography variant="body2" color="textSecondary">
                      {item.studentCpf}
                    </Typography>
                  </TableCell>
                  <TableCell className="subscription-history-table-cell">{item.createdAt}</TableCell>
                  <TableCell className="subscription-history-table-cell">{item.operation}</TableCell>
                  <TableCell className="subscription-history-table-cell">
                    <Button
                      onClick={() => handleDownloadDetails(item.id)}
                      disabled={downloadingPdf === item.id}
                      size="small"
                      color="primary"
                    >
                      {downloadingPdf === item.id ? (
                        <>
                          <CircularProgress size={16} style={{ marginRight: 8 }} />
                          Baixando...
                        </>
                      ) : (
                        'Detalhes'
                      )}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SubscriptionHistoryDialog
